import { StudentProps } from "../../Page/Students/components/types";
import Api from "../Helpers/Api";

class StudentsService {
  getStudents() {
    return Api.get(`/alunos`);
  }

  updateStudent(student: StudentProps) {
    return Api.get(`/alunos/atualizar`, student);
  }

  getStudentsFromColegio() {
    return Api.get('/alunos/colegio');
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new StudentsService();